import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatePresence, motion } from 'framer-motion';



export default function DropDown({ title = null, description = null, dropDownChildren = null }) {
    const [isOpen, setIsOpen] = useState(false);
    const { t } = useTranslation();

    const toggleOpen = () => setIsOpen(prev => !prev);

    return (
        <div>
            <div className="border p-4 rounded">
                <div className="flex justify-between items-start">
                    {/* Titolo dinamico */}
                    <p className="font-semibold">{title}</p>

                    {/* Bottone per aprire/chiudere */}
                    <button
                        onClick={toggleOpen}
                        className="text-sm font-medium text-yellow-600 hover:underline flex items-center"
                    >
                        {isOpen ? t('cyber_surveillance.hide_suggestions') : t('cyber_surveillance.show_suggestions')}
                    </button>
                </div>

                {/* Descrizione dinamica */}
                <p className="text-sm text-gray-600 mt-1">
                    <span className="font-medium">{description}</span>
                </p>

                {/* Animazione di apertura/chiusura */}
                <AnimatePresence initial={false}>
                    {isOpen && (
                        <motion.div
                            key="dropdown"
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: 'auto', opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.3, ease: 'easeInOut' }}
                            className="overflow-hidden border border-gray-400 rounded-md mt-5"
                        >
                            <div className="text-sm flex flex-col text-gray-700 p-5">
                                {dropDownChildren}
                            </div>
                        </motion.div>
                    )}
                </AnimatePresence>
            </div>
        </div>
    );
}
